<template>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="mb-6" v-if="viewRestaurant" >
          <div class=" mb-3" >
            <a
              target="_blank"
              :href="$router.resolve({ name: 'publicRestaurant', params: { slug: restaurant.slug, lang: language }}).href"
              class="mr-1"
            >
              <vs-button
                type="border"
                >
                {{ $t('restaurant.VerRestaurante') }}
              </vs-button>
            </a>
            <router-link :to="{ name: 'editRestaurant'}" >
              <vs-button
                type="border"
                class="mr-1"
              >
              {{ $t('Editar') }}
              </vs-button>
            </router-link>

            <router-link :to="{ name: 'report', params: {id:restaurant.id}}" >
              <vs-button
                type="border"
                class="mr-1"
              >
              {{ $t('DownloadReport') }}
              </vs-button>
            </router-link>

            <generate-qr
              :id="restaurant.id"
              type="restaurant"
              classSpan="vs-button vs-button-primary vs-button-border"
            />
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-2/12 ">
              <vx-input-group class="">
                <div>
                <label class="mt-2"> {{ $t('fidelization.Loyalty') }}</label>
                <vs-switch class="mt-3" v-model="fidelization_allowed" />
                </div>
              </vx-input-group>
            </div>
            <ValidationObserver ref="form">
              <div class="vx-col md:w-11/12 " v-if="fidelization_allowed">
                <vx-input-group class="mb-2 mt-3" >
                  <ValidationProvider name="Número de usos" rules="required|min_value:1" v-slot="{ errors }">
                    <vs-input label-placeholder="Número de usos" v-model="number_of_uses" type="number" class="w-full" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </vx-input-group>
              </div>
            </ValidationObserver>
          <div class="vx-col md:w-2/12 ">
            <vx-input-group class="mb-2 mt-3" >
                    <vs-button
                      type="border"
                      class="ml-1 mt-4 small"
                      @click="submitInfoFidelization()"
                    >
                      {{ $t('fidelization.UpdateLoyalty') }}
                    </vs-button>
                </vx-input-group>
              </div>
          </div>
          <view-restaurant :restaurant="restaurant" v-if="viewRestaurant" ></view-restaurant>
        </vx-card>
        <vx-card class="mb-6" v-if="viewRestaurant" >
          <team-restaurant :restaurant="restaurant" ></team-restaurant>
        </vx-card>
        <vx-card class="mb-6" v-if="viewRestaurant" >
          <tables-restaurant :restaurant="restaurant" ></tables-restaurant>
        </vx-card>
      </div>
    </div>
</template>

<script>
  import ViewRestaurant from '../components/Restaurants/ViewRestaurant';
  import TablesRestaurant from '../components/Tables/TablesRestaurant';
  import TeamRestaurant from '../components/Restaurants/TeamRestaurant';
  import GenerateQr from '../components/GenerateQr';
  import {mapActions, mapGetters} from 'vuex';
  import AllowFidelization from '../components/Restaurants/AllowFidelization.vue';

  export default {
    components: {
      ViewRestaurant,
      TablesRestaurant,
      TeamRestaurant,
      GenerateQr,
      AllowFidelization
    },
    data () {
      return {
        fidelization_allowed:false,
        number_of_uses:0,
        unknown:0,
      }
    },
    async created () {
      await this.getRestaurant({ id: this.currentRestaurant, language: this.language});
      if (this.restaurant.loyalty.length > 0) {
        this.fidelization_allowed = this.restaurant.loyalty[0].loyalty
        this.number_of_uses = this.restaurant.loyalty[0].uses
      }
    },
    computed: {
      ...mapGetters({
        currentRestaurant: 'getCurrentRestaurant',
        restaurant: 'getRestaurant',
        language: 'getCurrentLanguage'
      }),
       popupAllowFidelization: {
                get ()    { return this.$store.getters.getpopupAllowFidelization },
                set (val) { this.$store.commit('setpopupAllowFidelization', val) }
      },
      openModal () {
                if (this.popupAllowFidelization === true && this.fidelization_allowed === true) {
                    return true;
                }
                return false;
      },
      viewRestaurant () {
        return Object.keys(this.restaurant).length;
      },
        viewTables () {
        return Object.keys(this.tables).length;
      },
    },
    methods: {
      ...mapActions({
        getRestaurant: 'getRestaurant',
        submitInfo:'submitInfo'
      }),
      showErrorMessage() {
        setTimeout(() => {
          let textAux = '';
          const errors = this.$refs.form.errors;
          Object.keys(errors).forEach((key) => {
            const error = errors[key];
            if (error.length) {
              error.forEach(function (text) {
                textAux += `<p>${text}</p>`;
              });
            }
          });
          this.$store.commit('notifications', {
            title: 'Existen errores en el formulario.',
            color: 'danger',
            text: textAux,
          });
          this.$store.commit('showNotifications', true);
        }, 100);
      },
      submitInfoFidelization() {
        this.$refs.form.validate().then((success) => {
          if (!success) {
            this.showErrorMessage();
            return;
          }
          const formData = this.createFormData();
          this.submitInfo({ formData });
        });
      },
      createFormData() {
        const data = new FormData();
        if (this.fidelization_allowed === true) this.fidelization_allowed = 1;
        data.append('restaurant_id',JSON.stringify(this.currentRestaurant));
        data.append('loyalty',JSON.stringify(this.fidelization_allowed));
        data.append('uses', this.number_of_uses);

        return data
      }
    }
  }
</script>

<style>
</style>
